import React from 'react'
import { WHITE } from '@styles/colors'

const PinSmall = () => {
  return (
    <svg
      fill='none'
      height='21'
      viewBox='0 0 22 30'
      width='21'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11 1.973c2.431 0 4.763.912 6.482 2.535 1.719 1.623 2.685 3.824 2.685 6.119 0 4.093-6.723 14.286-8.652 17.135a.6.6 0 01-.222.194.64.64 0 01-.586 0 .6.6 0 01-.222-.194c-1.93-2.848-8.652-13.042-8.652-17.135 0-2.295.966-4.496 2.685-6.12C6.238 2.886 8.568 1.974 11 1.974v0z'
        stroke={WHITE}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M11 14.088c2.025 0 3.667-1.55 3.667-3.461 0-1.912-1.642-3.462-3.667-3.462s-3.667 1.55-3.667 3.462c0 1.912 1.642 3.461 3.667 3.461z'
        stroke={WHITE}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default PinSmall
